import React from 'react';
import { Form } from 'react-bootstrap';
import SimpleSelect from '../../components/Utils/Select/SimpleSelect';

const reportsOptions = ability => {
  const reports = [
    {
      action: 'export',
      resource: 'AttendanceDetailReport',
      value: 'attendance-details-vertical',
      label: 'Detalle Asistencia (Antiguo)'
    },
    {
      action: 'export',
      resource: 'AttendanceRecordReport',
      value: 'attendance-record-report',
      label: 'Registro de Asistencias'
    },
    {
      action: 'export',
      resource: 'AttendanceTotalReport',
      value: 'attendance-record-total',
      label: 'Asistencia Totalizados'
    },
    { action: 'export', resource: 'AbsenceTotalizedReport', value: 'absence-report', label: 'Ausencias Totalizados' },
    {
      action: 'index',
      resource: 'OvertimeAgreementReport',
      value: 'overtime-agreement-report',
      label: 'Pactos de Horas Extras'
    },
    { action: 'export', resource: 'WorkedSundayReport', value: 'worked-sunday-report', label: 'Domingos Trabajados' },
    { action: 'export', resource: 'WorkedHolidayReport', value: 'worked-holiday-report', label: 'Reporte de Feriados Trabajados' },
    { action: 'index', resource: 'SimpleReport', value: 'simple-report', label: 'Simple de Asistencia' },
    { action: 'index', resource: 'ShiftSummaryReport', value: 'shift-summary-report', label: 'Resumen de Turnos' },
    {
      action: 'export',
      resource: 'ArrearsTotalizedReport',
      value: 'arrears-report',
      label: 'Tiempo Faltante Totalizados'
    },
    { action: 'export', resource: 'DelayReport', value: 'delay_report', label: 'Reporte de Atraso' },
    {
      action: 'export',
      resource: 'EarlyDeparturesReport',
      value: 'early_departures_report',
      label: 'Reporte de Salidas Anticipadas'
    }
  ];

  return reports
    .filter(report => ability.can(report.action, report.resource))
    .map(({ value, label }) => ({ value, label }));
};

const OtherReportsSelector = ({ selectedKey, setKey, ability }) => {
  const options = reportsOptions(ability);
  const selectedOption = options.find(opt => opt.value === selectedKey) || null;

  return (
    <Form.Group className={`other-reports-selector${selectedOption ? ' active' : ''}`} style={{ maxWidth: 350 }}>
      <SimpleSelect
        options={options}
        value={selectedOption}
        onChange={option => setKey(option?.value || '')}
        placeholder="Otros Reportes"
        classNamePrefix="other-reports-selector"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
      />
    </Form.Group>
  );
};

export default OtherReportsSelector;
